import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const ElectronicsTelecommunicationsHeader = () => {
  return (
    <CourseHeader
      title="Electronics &"
      highlight="Telecommunications"
      subtitle="Connect. Communicate. Innovate."
      backgroundImage="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default ElectronicsTelecommunicationsHeader;
